<template>
  <div :class="{'visible': visible}">
    <a href="https://www.go2roues-assurance.fr/" target="_blank" rel="noopener" class="button">OBTENIR UN DEVIS D'ASSURANCE &rarr;</a>
  </div>
</template>

<script>
export default {
  name: "AssuranceStickyCTA",
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    showHide(event) {
      if (event.detail > 2500 && !this.visible) {
        this.visible = true
      }
      if (event.detail < 2500 && this.visible) {
        this.visible = false
      }
    },
  },
  mounted() {
    document.addEventListener('g2rScroll', (event) => this.showHide(event))
  },
}
</script>

<style scoped lang="scss">
div {
  position: fixed;
  background-color: var(--header-bg);
  width: 100%;
  padding: .5rem;
  text-align: center;
  opacity: 0;
  transition: opacity .3s,transform .3s;
  font-family: "Saira Semi Condensed", sans-serif;

  &.visible {
    opacity: .9;
    transform: translateY(0);
  }

  .button {
    padding: .6rem 2rem .5rem;
    background-color: var(--red);

    &:hover {
      background-color: #ff4341;
    }
  }
}

@media screen and (max-width: 1023px) {
  div {
    bottom: 0;
    transform: translateY(3rem);
  }
}

@media screen and (min-width: 1024px) {
  div {
    top: 0;
    transform: translateY(-3rem);
    text-align: right;
  }
}
</style>
